import { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { AgentContext } from '../Context/AgentContext';

const validationSchema = Yup.object({
  side: Yup.string()
    .typeError('سمت الزامی است')
    .required('سمت الزامی است')
    .max(190, 'سمت نمی تواند بیشتر از 190 کاراکتر باشد'),
});

const Edit = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const { id } = useParams();
  const context = useContext(AgentContext);
  const [serverErrors, setServerErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const { put, get } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      await getAgent();
    };
    getData();
  }, [id]);

  const getAgent = async () => {
    setLoading(true);
    await get(
      `/agent/${id}`,
      (res) => {
        context.agent = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات ناموفق بود');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await put(
      `/agent/${id}`,
      values,
      (res) => {
        success(`عوامل اجرایی "${values?.side}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        navigate(`/agent/edit/${id}`);
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`عوامل اجرایی "${values?.side}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ویرایش عوامل اجرایی'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/agent'
      />
      <Form
        initialValues={{
          side: context.agent?.side,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-12'>
            <div className='row'>
              <div className='col-12'>
                <Text title='سمت' name='side' serverError={serverErrors.side} />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Edit;
